import GatewayAPI from "./GatewayAPI";
import AuthAPI from "./AuthAPI";

class HttpClient {
  constructor() {
    this.gateway = new GatewayAPI();
    this.auth = new AuthAPI();
  }

  setTenantUid(uid) {
    this.gateway.setTenantUid(uid);
    this.tenantUid = uid;
  }
}

var client = new HttpClient();

export default client;
